import axios from "axios";

export const filterProducts = async (values, authtoken) =>
  await axios.post(`${process.env.REACT_APP_API}/filter/accounts`, values, {
    headers: {
      authtoken,
    },
  });

export const createGroupSetting = async (values, authtoken) =>
  await axios.post(`${process.env.REACT_APP_API}/accounts/group/create`, values, {
    headers: {
      authtoken,
    },
  });


export const getAllGroups = async (company, authtoken) =>
  await axios.post(`${process.env.REACT_APP_API}/account/groups?company=${company}`, {}, {
    headers: {
      authtoken,
    },
  });

export const createSubGroup = async (values, authtoken) =>
  await axios.post(`${process.env.REACT_APP_API}/account/groups/add-sub`, values, {
    headers: {
      authtoken,
    },
  });

export const getSubGroup = async (group) => {
  await axios.get(`${process.env.REACT_APP_API}/account/test-sub`);
}


export const getGroup = async (slug) =>
  await axios.get(`${process.env.REACT_APP_API}/account/group/${slug}`);

export const createSubTransactions = async (values, authtoken) =>
  await axios.post(`${process.env.REACT_APP_API}/account/group/sub-transactions`, values, {
    headers: {
      authtoken,
    },
  });


export const gstVerification = async (value) =>
  await axios.get(`${process.env.REACT_APP_API}/account/gst/${value}`);

export const checkStockSpeed = async (store) =>
  await axios.get(`${process.env.REACT_APP_API}/calculate/stock-speed?store=${store}`);

export const updateStockManually = async (quantity, slug, product, authtoken) =>
  await axios.post(`${process.env.REACT_APP_API}/store/update-stock`, { quantity, slug, product }, {
    headers: {
      authtoken,
    },
  });

export const updateBarcodeManually = async (quantity, slug, product, authtoken) =>
  await axios.post(`${process.env.REACT_APP_API}/store/update-barcode`, { quantity, slug, product }, {
    headers: {
      authtoken,
    },
  });

export const sendStockEMail = async (quantity, slug, product, authtoken) =>
  await axios.post(`${process.env.REACT_APP_API}/store/email-stock`, { quantity, slug, product }, {
    headers: {
      authtoken,
    },
  });

export const getStockReport = async (slug, product, authtoken) =>
  await axios.post(`${process.env.REACT_APP_API}/store/report-stock`, { slug, product }, {
    headers: {
      authtoken,
    },
  });

export const checkVariety = async (authtoken) =>
  await axios.post(`${process.env.REACT_APP_API}/admin/variety-check`, {}, {
    headers: {
      authtoken,
    },
  });


export const removeGroup = async (slug, authtoken) =>
  await axios.delete(`${process.env.REACT_APP_API}/group/${slug}`, {
    headers: {
      authtoken,
    },
  });

export const getStoreExpiries = async (store, authtoken) =>
  await axios.get(`${process.env.REACT_APP_API}/store/get-expiries?store=${store}`, {
    headers: {
      authtoken,
    },
  });

export const deleteExpiryDate = async (id, store, authtoken) =>
  await axios.post(`${process.env.REACT_APP_API}/store/delete-expiry/date`, { id, store }, {
    headers: {
      authtoken,
    },
  });

export const fixStoreInventory = async (store, authtoken) =>
  await axios.post(`${process.env.REACT_APP_API}/store/fix-stock`, { store: store }, {
    headers: {
      authtoken,
    },
  });